export default {
    poweredBy: "Zasilany przez"
}